import { render, staticRenderFns } from "./TaskDetailsCard.vue?vue&type=template&id=14bb6b25&scoped=true"
import script from "./TaskDetailsCard.vue?vue&type=script&lang=js"
export * from "./TaskDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailsCard.vue?vue&type=style&index=0&id=14bb6b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb6b25",
  null
  
)

export default component.exports